<template>
  <form @submit.prevent="submit">
    <div class="field">
      <label>Proveedor de IA</label>
      <Dropdown v-model="form.ai_provider_id" :options="providers" optionLabel="name" optionValue="id"
        placeholder="Selecciona un proveedor" class="w-full" />
    </div>
    <div class="field">
      <label>API Key</label>
      <Password v-model="form.api_key" class="w-full" :feedback="false" toggleMask />
    </div>
    <Button label="Guardar credencial global" type="submit" :loading="loading" class="w-full" />
  </form>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Dropdown from 'primevue/dropdown';
import Password from 'primevue/password';
import Button from 'primevue/button';
import api from '../../services/api';

const emit = defineEmits(['saved']);
const form = ref({ ai_provider_id: null, api_key: '' });
const providers = ref([]);
const loading = ref(false);

onMounted(async () => {
  try {
    // Obtener proveedores disponibles desde el backend cuando esté implementado
    providers.value = [
      { id: 1, name: 'Mistral AI' },
      { id: 2, name: 'OpenAI' },
    ];
  } catch (e) { console.error(e); }
});

const submit = async () => {
  loading.value = true;
  try {
    await api.post('/credentials/global', form.value);
    emit('saved');
    form.value = { ai_provider_id: null, api_key: '' };
  } catch (e) { console.error(e); }
  finally { loading.value = false; }
};
</script>

<style scoped>
.field { margin-bottom: 1rem; }
.field label { display: block; margin-bottom: 0.4rem; font-weight: 500; }
.w-full { width: 100%; }
</style>
